import { render, staticRenderFns } from "./JournalManagement.vue?vue&type=template&id=4a623d56"
import script from "./JournalManagement.vue?vue&type=script&lang=js"
export * from "./JournalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports